import { PresetVisibility } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils';
import { Stack, Switch, SwitchProps, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { LockIcon } from '../lock-icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccessSettingsProps as Props } from './types';

export const AccessSettings = memo(({ className, onSubmit, item }: Props) => {
  const initialChecked = item?.visibility === PresetVisibility.PRIVATE;

  const [checked, setChecked] = useState(initialChecked);

  const handleChangeSwitch: SwitchProps['onChange'] = (e) => {
    setChecked(e.target.checked);
    const visibility = e.target.checked
      ? PresetVisibility.PRIVATE
      : PresetVisibility.INTERNAL;

    // Check if the toggle has been changed from its original state
    const hasChanged = e.target.checked !== initialChecked;

    onSubmit?.(visibility, hasChanged);
  };

  return (
    <Styled.Wrapper
      className={classnames('AccessSettings', className)}
      sx={SX.root}
    >
      <Typography variant="body5" fontWeight={500} color="grey.700">
        Access Settings:
      </Typography>

      <Stack direction="row" alignItems="center" gap={0.5}>
        <LockIcon />

        <Typography variant="body5" fontWeight={500} color="grey.700">
          Private
        </Typography>

        <Switch checked={checked} onChange={handleChangeSwitch} size="small" />
      </Stack>
    </Styled.Wrapper>
  );
});

AccessSettings.displayName = 'AccessSettings';
